const PILLARS = [
  { icon: "ri-heart-line", title: "恋爱题材", text: "围绕心动、告白与关系升温展开，画风清新温暖，节奏明快。", tone: "text-primary-600 bg-primary-100" },
  { icon: "ri-bard-line", title: "系统流叙事", text: "以「恋爱辅助器」为核心道具，通过任务与数值推动剧情。", tone: "text-accent-700 bg-accent-100" },
  { icon: "ri-bubble-chart-line", title: "成长治愈", text: "主角在一次次尝试中走出社恐，学会表达与真诚待人。", tone: "text-secondary-700 bg-secondary-100" },
];

export default function Overview() {
  return (
    <section id="intro" className="relative mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
      <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
            <i className="ri-heart-3-line"></i>
            入门导读
          </span>
          <h2 className="mt-5 font-heading text-3xl leading-snug text-foreground-900 md:text-4xl">
            恋爱辅助器漫画<span className="text-primary-600">是什么</span>？
          </h2>
          <p className="mt-5 text-base leading-relaxed text-foreground-700">
            《恋爱辅助器》是一部以「恋爱系统」为核心设定的浪漫治愈系漫画。故事里，一名性格内向、常年不敢主动表达的普通青年，
            意外被一台神秘的「恋爱辅助器」绑定。这台装置会实时给出心动值、好感度反馈，并不断发布关于约会、相处与告白的小任务，
            一步步把他推进原本不敢触碰的恋爱世界。
          </p>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            它并不只是一部简单的「恋爱爽文」——辅助器的每一项数值与规则，都藏着关于勇气、真诚与自我成长的内核。
            看似在攻略别人，实则也在一点点治愈主角自己。
          </p>

          <div className="mt-8 grid gap-4 sm:grid-cols-3">
            {PILLARS.map((p) => (
              <div key={p.title} className="rounded-2xl border border-background-200 bg-background-50 p-4">
                <span className={`flex h-10 w-10 items-center justify-center rounded-xl ${p.tone}`}>
                  <i className={`${p.icon} text-lg`}></i>
                </span>
                <h3 className="mt-3 text-sm font-bold text-foreground-900">{p.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{p.text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="overflow-hidden rounded-3xl">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20anime%20manga%20illustration%20of%20a%20floating%20smartphone%20surrounded%20by%20glowing%20pink%20hearts%2C%20heart-shaped%20UI%20panels%20and%20golden%20notification%20bubbles%20with%20heart%20icons%2C%20warm%20coral%20and%20gold%20palette%20on%20soft%20cream%20background%2C%20romantic%20webtoon%20infographic%20style%2C%20clean%20detailed%20illustration%2C%20dreamy%20soft%20lighting%2C%20no%20text&width=900&height=700&seq=lovecomic-intro&orientation=portrait"
              alt="恋爱辅助器漫画中的恋爱系统手机界面概念插画，飘浮的爱心与UI面板"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-5 -left-5 hidden rounded-2xl bg-accent-500 px-5 py-4 text-background-50 shadow-lg md:block">
            <p className="font-heading text-2xl leading-none">暖心</p>
            <p className="mt-1 text-sm">系统陪伴式成长</p>
          </div>
          <div className="absolute -top-5 -right-3 hidden animate-floaty rounded-2xl bg-primary-500 px-5 py-4 text-background-50 shadow-lg md:block">
            <p className="flex items-center gap-2 text-sm">
              <i className="ri-heart-3-fill"></i> 心动值实时反馈
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}